import { useCallback } from 'react';
import { ChangeRequestDirection } from '../enums/changeRequest';
import { UseChangeRequestEditFormHookProps } from '../interfaces/changeRequestProps';
import { confirmAction } from '../utils/confirmActionModal';
import { ChecklistItem, ExecutionItem } from '../interfaces/changeRequest';
import { setRevokeAPICall } from '../services/copilotThread.service';

export function useChangeRequestEditForm({
  onClose,
  onNavigate,
  isDirty,
  setIsDirty,
}: UseChangeRequestEditFormHookProps) {
  const handleClose = useCallback(async () => {
    if (isDirty) {
      const confirmLeave = await confirmAction({
        title: 'You have unsaved changes. Are you sure you want to leave?',
        okText: 'Leave',
      });
      if (!confirmLeave) return;
    }
    setIsDirty(false);
    onClose();
  }, [isDirty, onClose]);

  const handleNavigate = useCallback(
    async (direction: ChangeRequestDirection) => {
      if (isDirty) {
        const confirmLeave = await confirmAction({
          title: 'You have unsaved changes. Are you sure you want to navigate?',
          okText: 'Navigate',
        });
        if (!confirmLeave) return;
      }
      setRevokeAPICall(true);
      setIsDirty(false);
      onNavigate(direction);
    },
    [isDirty, onNavigate]
  );

  const onValuesChange = useCallback(
    <T extends ChecklistItem | ExecutionItem>(
      editingRecord: T,
      formValues: T
    ): T => {
      const updatedValues = { ...editingRecord, ...formValues };
      const isModified =
        JSON.stringify(updatedValues) !== JSON.stringify(editingRecord);
      setIsDirty(isModified);
      return updatedValues;
    },
    []
  );

  return { isDirty, setIsDirty, handleClose, handleNavigate, onValuesChange };
}
